import React, { useEffect, useState } from 'react';
import { publicAds, adClick, adImpression, resolveFileUrl } from '../lib/api';
import { Megaphone, ExternalLink } from 'lucide-react';

export default function ChannelSponsorBlock({ channel }) {
  const [sponsorAd, setSponsorAd] = useState(null);

  useEffect(() => {
    if (!channel) return;
    (async () => {
      try {
        const list = await publicAds({ placement: 'channel_sponsor', channel_id: channel.id, limit: 5 });
        if (list && list.length) {
          const chosen = list[Math.floor(Math.random() * list.length)];
          setSponsorAd(chosen);
          adImpression(chosen.id);
        }
      } catch {}
    })();
  }, [channel]);

  if (!channel) return null;
  const hasNative = channel.sponsor_name || channel.sponsor_logo;
  if (!hasNative && !sponsorAd) return null;

  if (sponsorAd) {
    return (
      <a href={sponsorAd.link_url || '#'} target={sponsorAd.link_url ? '_blank' : undefined} rel="noreferrer" onClick={() => sponsorAd.link_url && adClick(sponsorAd.id)} className="card-shell p-4 flex items-center gap-4 hover-lift mt-5 block">
        <div className="w-14 h-14 rounded-xl overflow-hidden bg-white/5 border border-white/10 grid place-items-center">
          {sponsorAd.media_url ? <img src={resolveFileUrl(sponsorAd.media_url)} alt="" className="w-full h-full object-cover" /> : <Megaphone className="w-6 h-6 text-white/70" />}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider text-[#ffcf52]"><Megaphone className="w-3 h-3" /> Sponsor</div>
          <div className="font-semibold text-[15px] mt-0.5">{sponsorAd.headline}</div>
          {sponsorAd.body && <div className="text-[13px] text-white/65 line-clamp-1">{sponsorAd.body}</div>}
        </div>
        {sponsorAd.link_url && <div className="text-[13px] text-[#22d3ee] flex items-center gap-1 shrink-0">Visit <ExternalLink className="w-3.5 h-3.5" /></div>}
      </a>
    );
  }

  return (
    <a href={channel.sponsor_url || '#'} target={channel.sponsor_url ? '_blank' : undefined} rel="noreferrer" className="card-shell p-4 flex items-center gap-4 hover-lift mt-5 block">
      <div className="w-14 h-14 rounded-xl overflow-hidden bg-white/5 border border-white/10 grid place-items-center">
        {channel.sponsor_logo ? <img src={resolveFileUrl(channel.sponsor_logo)} alt={channel.sponsor_name} className="w-full h-full object-cover" /> : <Megaphone className="w-6 h-6 text-white/70" />}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider text-[#ffcf52]"><Megaphone className="w-3 h-3" /> Sponsored by</div>
        <div className="font-semibold text-[15px] mt-0.5">{channel.sponsor_name}</div>
        {channel.sponsor_tagline && <div className="text-[13px] text-white/65 line-clamp-1">{channel.sponsor_tagline}</div>}
      </div>
      {channel.sponsor_url && <div className="text-[13px] text-[#22d3ee] flex items-center gap-1 shrink-0">Visit <ExternalLink className="w-3.5 h-3.5" /></div>}
    </a>
  );
}
